import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme';
import { useNavigate, useRouteError } from 'react-router-dom';

import { Button } from '@independent-software/typeui/controls/Button';
import { Icon } from '@independent-software/typeui/controls/Icon';
import { Message } from '@independent-software/typeui/controls/Message';

interface IProps {
  className?: string;
}

const ErrorPageBase = (props: IProps) => {
  const navigate = useNavigate();
  const error: any = useRouteError();
  console.error(error);

  const handleClick = () => navigate('/');

  return (
    <div className={props.className}>
      <div>
        <Logo><use xlinkHref={"sprites.svg#aqua-logo-text"}></use></Logo>
        <Message type="error" attached="top" icon>
          <Icon name="times" size="big"/>          
          <Message.Content>
            <Message.Header>
              Routing error
            </Message.Header>            
            <p>An unexpected error has occurred.</p>
          </Message.Content>
        </Message>
        {error && <Message attached="bottom">
          <p>
            <b>{error.statusText || error.message}</b>
          </p>
          {error.data && error.data}
        </Message>}
        <Buttons>
          <Button secondary onClick={handleClick}>Return to root</Button>
        </Buttons>
      </div>
    </div>
  );
}

const ErrorPage = styled(ErrorPageBase)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;  
  & > div {
    margin-top: 20vh;
    width: 50vw;
  }
  background-image: linear-gradient(rgb(21, 71, 121), rgb(16, 108, 200));
`

const Buttons = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: end;
`

const Logo = styled.svg`
  width: 50vw;
  height: 100px;
  margin-bottom: 40px;
`

export { ErrorPage }
